import * as React from "react"
import { useTranslation } from "react-i18next"

import OptionList from "Catalog/Preview/Popup/shared/components/OptionList"
import ItemDealLine from "shared/hubrise/items/ItemDealLine"
import { IOptionList } from "shared/hubrise/models"

import { Toggle, ToggleIcon } from "../Styles"

import { OptionLists, StyledExpanded, Title } from "./Styles"

interface ExpandedProps {
  optionLists: Array<IOptionList>
  optionNames: (optionListName: string) => Array<string>
  setOptionNames: (optionListName: string, optionNames: Array<string>) => void
  itemDealLine: ItemDealLine
  collapse: () => void
  modalScrollableRef: React.RefObject<HTMLDivElement>
  stickyHeaderRef: React.RefObject<HTMLDivElement>
}

const Expanded = ({
  optionLists,
  optionNames,
  setOptionNames,
  itemDealLine,
  collapse,
  modalScrollableRef,
  stickyHeaderRef,
}: ExpandedProps) => {
  const { t } = useTranslation()

  const customiseTitleRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const { height: stickyHeaderHeight } = stickyHeaderRef.current!.getBoundingClientRect()
    const { top: currentTop } = customiseTitleRef.current!.getBoundingClientRect()
    // Scroll the modal so that the "customise" title aligns just below the modal sticky header
    const scrollOffset = currentTop - stickyHeaderHeight
    modalScrollableRef.current!.scrollBy({ top: scrollOffset, behavior: "smooth" })
  }, [modalScrollableRef, stickyHeaderRef])

  const fullSkuName = itemDealLine.itemDealLineSkus.find(({ skuId }) => skuId === itemDealLine.sku.id)!.name

  return (
    <StyledExpanded>
      <Title onClick={collapse} ref={customiseTitleRef}>
        {t("preview.popup.deal.customise", { name: fullSkuName })}
      </Title>

      <Toggle>
        <ToggleIcon code="keyboard_double_arrow_up" />
      </Toggle>

      <OptionLists>
        {optionLists.map((optionList) => (
          <OptionList
            key={optionList.id}
            optionList={optionList}
            optionNames={optionNames(optionList.name)}
            setOptionNames={(names) => setOptionNames(optionList.name, names)}
            namePrefix={`line${itemDealLine.index + 1}`}
          />
        ))}
      </OptionLists>
    </StyledExpanded>
  )
}

export default Expanded
